<div class="header">
  <div class="title">兼任(専門部)</div>
</div>
<mat-dialog-content>
  <div class="content">
    @if (showSpinner) {
      <div class="spinner center">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
      <div class="checkbox-grid">
        <ng-container *ngFor="let org of master4">
          <mat-checkbox class="thin-checkbox" [(ngModel)]="org.checked" disableRipple="true">{{org.name}}</mat-checkbox>
        </ng-container>
      </div>
}
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (isSaving) {
    <mat-spinner diameter="28" class="spinner"></mat-spinner>
  }
  <button mat-raised-button mat-dialog-close>キャンセル</button>
  <button mat-raised-button (click)="onSave()" [disabled]="isSaving || showSpinner" class="yes-btn">選択</button>
</mat-dialog-actions>
